import { defineComponent as C, computed as R, h as w, Comment as j } from "vue";
import { useRtl as G } from "./ghl-ui.es851.js";
import { ensureSupportFlexGap as I } from "./ghl-ui.es1096.js";
import M from "./ghl-ui.es854.js";
import b from "./ghl-ui.es855.js";
import { createKey as P } from "./ghl-ui.es384.js";
import { getGap as T, depx as x } from "./ghl-ui.es856.js";
import { flatten as A } from "./ghl-ui.es932.js";
import { getSlot as E } from "./ghl-ui.es1086.js";
import L from "./ghl-ui.es1097.js";
const O = Object.assign(Object.assign({}, b.props), {
  align: String,
  justify: {
    type: String,
    default: "start"
  },
  inline: Boolean,
  vertical: Boolean,
  reverse: Boolean,
  size: {
    type: [String, Number, Array],
    default: "medium"
  },
  wrapItem: {
    type: Boolean,
    default: !0
  },
  itemClass: String,
  itemStyle: [String, Object],
  wrap: {
    type: Boolean,
    default: !0
  },
  // internal
  internalUseGap: {
    type: Boolean,
    default: void 0
  }
}), q = C({
  name: "Space",
  props: O,
  setup(e) {
    const {
      mergedClsPrefixRef: a,
      mergedRtlRef: f
    } = M(e), g = b("Space", "-space", void 0, L, e, a), t = G("Space", f, a);
    return {
      useGap: I(),
      rtlEnabled: t,
      mergedClsPrefix: a,
      margin: R(() => {
        const {
          size: r
        } = e;
        if (Array.isArray(r))
          return {
            horizontal: r[0],
            vertical: r[1]
          };
        if (typeof r == "number")
          return {
            horizontal: r,
            vertical: r
          };
        const {
          self: {
            [P("gap", r)]: u
          }
        } = g.value, {
          row: n,
          col: d
        } = T(u);
        return {
          horizontal: x(d),
          vertical: x(n)
        };
      })
    };
  },
  render() {
    const {
      vertical: e,
      reverse: a,
      align: f,
      inline: g,
      justify: t,
      itemClass: r,
      itemStyle: u,
      margin: n,
      wrap: d,
      mergedClsPrefix: h,
      rtlEnabled: v,
      useGap: l,
      wrapItem: z,
      internalUseGap: B
    } = this, p = A(E(this), !1);
    if (!p.length)
      return null;
    const S = `${n.horizontal}px`, m = `${n.horizontal / 2}px`, $ = `${n.vertical}px`, i = `${n.vertical / 2}px`, s = p.length - 1, c = t.startsWith("space-");
    return w("div", {
      role: "none",
      class: [`${h}-space`, v && `${h}-space--rtl`],
      style: {
        display: g ? "inline-flex" : "flex",
        flexDirection: (() => e && !a ? "column" : e && a ? "column-reverse" : !e && a ? "row-reverse" : "row")(),
        justifyContent: ["start", "end"].includes(t) ? "flex-" + t : t,
        flexWrap: !d || e ? "nowrap" : "wrap",
        marginTop: l || e ? "" : `-${i}`,
        marginBottom: l || e ? "" : `-${i}`,
        alignItems: f,
        gap: l ? `${n.vertical}px ${n.horizontal}px` : ""
      }
    }, !z && (l || B) ? p : p.map((y, o) => y.type === j ? y : w("div", {
      role: "none",
      class: r,
      style: [u, {
        maxWidth: "100%"
      }, l ? "" : e ? {
        marginBottom: o !== s ? $ : ""
      } : v ? {
        marginLeft: c ? t === "space-between" && o === s ? "" : m : o !== s ? S : "",
        marginRight: c ? t === "space-between" && o === 0 ? "" : m : "",
        paddingTop: i,
        paddingBottom: i
      } : {
        marginRight: c ? t === "space-between" && o === s ? "" : m : o !== s ? S : "",
        marginLeft: c ? t === "space-between" && o === 0 ? "" : m : "",
        paddingTop: i,
        paddingBottom: i
      }]
    }, y)));
  }
});
export {
  q as default,
  O as spaceProps
};
